<template>
  <messenger
    @locale-changed="handleLocaleChanged"
    :title="space.name"
    :description="t('components.messenger.problems.description')"
    :back-link="route('space.select', [tenant.slug])"
    :back-link-label="
      t('components.messenger.welcome.title', { tenant: tenant.name })
    "
  >
    <template v-slot:content>
      <div class="flex flex-col h-full">
        <MessengerTabs
          class="grow"
          :tabs="tabs"
          :initialIndex="!!documents.length ? 0 : 1"
        />
        <div class="p-4 flex border-t border-gray-200">
          <primary-button
            class="grow"
            :label="t('components.messenger.welcome.cta')"
            @click="handleReportNewProblem"
            :loading="isLoading"
          />
        </div>
      </div>
    </template>
  </messenger>
</template>

<script setup>
import { usePage } from "@inertiajs/vue3";
import PrimaryButton from "@/Tailwind/Components/Buttons/PrimaryButton.vue";
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import Messenger from "@/Tailwind/Layouts/Messenger.vue";
import { computed, ref } from "vue";

import { useI18n } from "vue-i18n";
import { useCookies } from "vue3-cookies";
import DocumentsList from "@/Tailwind/Components/Messenger/Lists/DocumentsList.vue";
import ProblemsList from "@/Tailwind/Components/Messenger/Lists/ProblemsList.vue";
import MessengerTabs from "@/Tailwind/Components/Messenger/MessengerTabs.vue";

const { t } = useI18n();
const { cookies } = useCookies();

const locale = usePage().props.locale;
const currentLocale = ref(cookies.get("messenger_locale") || locale);

const props = defineProps({
  documents: Array,
});

const documents = computed(() => {
  return props.documents.map((document) => ({
    ...document.file,
    title: document.title,
  }));
});
const problems = usePage().props.problems;

const tabs = computed(() => [
  {
    key: "documents",
    label: t("components.messenger.problems.documents"),
    count: documents.value.length,
    component: DocumentsList,
    componentAttributes: {
      documents: documents.value,
    },
    emptyTitle: t("components.messenger.problems.no_documents"),
    emptyDescription: t("components.messenger.problems.no_documents_desc"),
    emptyImage: "/images/empty/documents.svg",
    disabled: documents.value.length === 0,
  },
  {
    key: "problems",
    label: t("components.messenger.problems.previously_reported"),
    count: problems.length,
    component: ProblemsList,
    componentAttributes: {
      problems: problems,
    },
    emptyTitle: t("components.messenger.problems.no_prev_reported"),
    emptyDescription: t("components.messenger.problems.no_prev_reported_desc"),
    emptyImage: "/images/empty/updates.svg",
  },
]);

const isLoading = ref(false);
const tenant = usePage().props.tenant;
const space = usePage().props.space;

function handleLocaleChanged(locale) {
  currentLocale.value = locale;
}

function handleReportNewProblem() {
  router.get(
    route("problem.draft", [tenant.slug, space.id]),
    {},
    {
      onStart: () => (isLoading.value = true),
      onFinish: () => (isLoading.value = false),
    }
  );
}
</script>
